// Generated automatically before each production build.
export const CURRENT_BUILD_VERSION = "1792003723263";
